import React from "react";

export const paymentMethodNamesGeneral = {
  CASH: "CASH",
  CARD: "CARD",
  option_at_pickup: "At pickup",
};

export const paymentMethodNamesPaynl = {
  IDEAL: "iDeal",
  GIROPAY: "Giropay",
  SOFORT: "Sofort",
  BANCONTACT: "Bancontact",
  IDEALQR: "iDEAL QR",
  PAYPAL: "PayPal",
  MASTERCARD: "Mastercard",
  PAYCONIQ: "Payconiq",
  EPS: "EPS Überweisung",
  VISA: "VISA",
  AMEX: "American Expresss",
};

export const paymentMethodNamesOpp = {
  OPP_IDEAL: "iDeal",
  OPP_GIROPAY: "Giropay",
  OPP_SOFORT: "Sofort",
  OPP_BANCONTACT: "Bancontact",
  OPP_PAYPAL: "PayPal",
  OPP_CREDITCARD: "Creditcard",
};
